// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes _1uq32v21 {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
._1uq32v20 {
  position: relative;
}
._1uq32v22 {
  position: absolute;
  background: linear-gradient(90deg,rgba(234, 234, 234, 0) 0%,#eaeaea 67.71%,rgba(234, 234, 234, 0) 100%);
  animation: _1uq32v21 1.8s ease-in-out infinite;
  animation-timing-function: cubic-bezier(0.7, -0.4, 0.4, 1.4);
}
._1uq32v23 {
  position: relative;
  overflow: hidden;
  background-color: #F7F7F7;
}
._1uq32v27 {
  width: var(--_1uq32v24);
}
._1uq32v2d {
  height: var(--_1uq32v2a);
}
._1uq32v2j {
  aspect-ratio: var(--_1uq32v2g);
}
._1uq32v2p {
  border-radius: var(--_1uq32v2m);
}
@media screen and (min-width: 768px)  {
  ._1uq32v28 {
    width: var(--_1uq32v25);
  }
  ._1uq32v2e {
    height: var(--_1uq32v2b);
  }
  ._1uq32v2k {
    aspect-ratio: var(--_1uq32v2h);
  }
  ._1uq32v2q {
    border-radius: var(--_1uq32v2n);
  }
}
@media screen and (min-width: 1024px)  {
  ._1uq32v29 {
    width: var(--_1uq32v26);
  }
  ._1uq32v2f {
    height: var(--_1uq32v2c);
  }
  ._1uq32v2l {
    aspect-ratio: var(--_1uq32v2i);
  }
  ._1uq32v2r {
    border-radius: var(--_1uq32v2o);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uGAAuG;EACvG,8CAA8C;EAC9C,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["@keyframes _1uq32v21 {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n._1uq32v20 {\n  position: relative;\n}\n._1uq32v22 {\n  position: absolute;\n  background: linear-gradient(90deg,rgba(234, 234, 234, 0) 0%,#eaeaea 67.71%,rgba(234, 234, 234, 0) 100%);\n  animation: _1uq32v21 1.8s ease-in-out infinite;\n  animation-timing-function: cubic-bezier(0.7, -0.4, 0.4, 1.4);\n}\n._1uq32v23 {\n  position: relative;\n  overflow: hidden;\n  background-color: #F7F7F7;\n}\n._1uq32v27 {\n  width: var(--_1uq32v24);\n}\n._1uq32v2d {\n  height: var(--_1uq32v2a);\n}\n._1uq32v2j {\n  aspect-ratio: var(--_1uq32v2g);\n}\n._1uq32v2p {\n  border-radius: var(--_1uq32v2m);\n}\n@media screen and (min-width: 768px)  {\n  ._1uq32v28 {\n    width: var(--_1uq32v25);\n  }\n  ._1uq32v2e {\n    height: var(--_1uq32v2b);\n  }\n  ._1uq32v2k {\n    aspect-ratio: var(--_1uq32v2h);\n  }\n  ._1uq32v2q {\n    border-radius: var(--_1uq32v2n);\n  }\n}\n@media screen and (min-width: 1024px)  {\n  ._1uq32v29 {\n    width: var(--_1uq32v26);\n  }\n  ._1uq32v2f {\n    height: var(--_1uq32v2c);\n  }\n  ._1uq32v2l {\n    aspect-ratio: var(--_1uq32v2i);\n  }\n  ._1uq32v2r {\n    border-radius: var(--_1uq32v2o);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
